import React from 'react';
import PropTypes from 'prop-types';
import './tbhProfileHeader.scss';

const TbhProfileHeader = ({ tbhData}) => {
  // Mapping the backend response keys to the profile header display
  const {
    region_name = '-',
    country_name = '-',
    employee_vertical_name = '-',
    dept_name = '-',
    employee_contract_type = '-',
    role_name = '-',
  } = tbhData || {};

  return (
    <div className="tbh-profile-header-container">
      {/* Box 1: Region & Country */}
      <div className="profile-info-box">
        <div className="info-row">
          <span className="info-label">TBH Region</span>
          <span className="info-value">{region_name}</span>
        </div>
        <div className="info-row">
          <span className="info-label">TBH Country</span>
          <span className="info-value">{country_name}</span>
        </div>
      </div>

      {/* Box 2: Vertical & Department */}
      <div className="profile-info-box">
        <div className="info-row">
          <span className="info-label">TBH Vertical</span>
          <span className="info-value">{employee_vertical_name}</span>
        </div>
        <div className="info-row">
          <span className="info-label">TBH Department</span>
          <span className="info-value">{dept_name}</span>
        </div>
      </div>

      {/* Box 3: Contract Type & Role */}
      <div className="profile-info-box">
        <div className="info-row">
          <span className="info-label">TBH Contract Type</span>
          <span className="info-value">{employee_contract_type}</span>
        </div>
        <div className="info-row">
          <span className="info-label">TBH Role</span>
          <span className="info-value">{role_name}</span>
        </div>
      </div>
    </div>
  );
};

TbhProfileHeader.propTypes = {
  tbhData: PropTypes.shape({
    region_name: PropTypes.string,
    country_name: PropTypes.string,
    employee_vertical_name: PropTypes.string,
    dept_name: PropTypes.string,
    employee_contract_type: PropTypes.string,
    role_name: PropTypes.string,
  }),
  loading: PropTypes.bool,
};

TbhProfileHeader.defaultProps = {
  tbhData: {},
  loading: false,
};

export default TbhProfileHeader;
